export default "__VITE_ASSET__CBHSzveT__"